import { render, staticRenderFns } from "./TradableTermsSummary.vue?vue&type=template&id=2669965f&scoped=true"
import script from "./TradableTermsSummary.vue?vue&type=script&lang=js"
export * from "./TradableTermsSummary.vue?vue&type=script&lang=js"
import style0 from "./TradableTermsSummary.vue?vue&type=style&index=0&id=2669965f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669965f",
  null
  
)

export default component.exports